import { useQuery } from '@apollo/client'
import { RecruiterMe } from 'recruiter/graphql/admin.gql'
import { recruiterRouteConfig } from 'recruiter/routes'
import { TopNavigation } from 'shared/components/TopNavigation'
import { GlobalSearch } from './GlobalSearch'

const baseLinks = [
    {
        label: 'Research',
        path: recruiterRouteConfig.research.path,
    },
    {
        label: 'Searches',
        path: recruiterRouteConfig.rosters.path,
    },
    {
        label: 'Companies',
        path: recruiterRouteConfig.companies.path,
    },
]

export function RecruiterTopNavigation() {
    const { data } = useQuery(RecruiterMe)
    const isAdmin = data?.recruiterMe?.isAdmin ?? false

    const links = isAdmin
        ? [
              ...baseLinks,
              { label: 'Admin', path: recruiterRouteConfig.admin.path },
          ]
        : baseLinks

    return <TopNavigation links={links} centerContent={<GlobalSearch />} />
}
